import { action, decorate, observable, computed } from "mobx";

class TrimPlayDialogStore {
  constructor(reelStore) {
    this.reelStore = reelStore;
  }

  isOpen = false;
  src = "";
  startOffset = 0;
  endOffset = 0;

  open(clip, index) {
    this.src = clip.url;
    this.startOffset = clip.startOffset;
    this.endOffset = clip.endOffset;
    this.index = index;
    this.isOpen = true;
  }

  save(videoDuration) {
    let attrs = {
      startOffset: this.startOffset,
      endOffset: this.endOffset,
      videoDuration
    };

    this.reelStore.updateReelClip(this.index, attrs);
    this.isOpen = false;
  }

  get startOffsetDisplay() {
    return this._formatOffsetString(this.startOffset);
  }

  get endOffsetDisplay() {
    return this._formatOffsetString(this.endOffset);
  }

  clear() {
    this.src = "";
    this.index = -1;
    this.startOffset = 0;
    this.endOffset = 0;
  }

  _formatOffsetString(offset) {
    const minutes = Math.floor(offset / 60)
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor(offset % 60)
      .toString()
      .padStart(2, "0");
    const milliseconds = Math.floor((offset % 1) * 1000)
      .toString()
      .padStart(3, "0");
    return `${minutes}:${seconds}.${milliseconds}`;
  }
}

decorate(TrimPlayDialogStore, {
  isOpen: observable,
  startOffset: observable,
  endOffset: observable,
  src: observable,
  open: action,
  save: action,
  clear: action,
  startOffsetDisplay: computed,
  endOffsetDisplay: computed
});

export default TrimPlayDialogStore;



// WEBPACK FOOTER //
// ./src/stores/TrimPlayDialogStore.js